window.theme = window.theme || {};
theme.customerTemplates = (function(){

  function initEventListeners(){
    // Show reset password form
    var recoverPasswordLink = document.getElementById('RecoverPassword');
    if (recoverPasswordLink){
      recoverPasswordLink.addEventListener('click', function(evt){
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    // Hide reset password form
    var hideRecoverPasswordLink = document.getElementById('HideRecoverPasswordLink');
    if (hideRecoverPasswordLink){
      hideRecoverPasswordLink.addEventListener('click', function(evt){
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  }

  /****  Show/Hide recover password form **/
  function toggleRecoverPasswordForm(){
    var recoverPasswordForm = document.getElementById('RecoverPasswordForm');
    var customerLoginForm = document.getElementById('CustomerLoginForm');

    if (recoverPasswordForm){
      recoverPasswordForm.classList.toggle('hide');
    }

    if (customerLoginForm){
      customerLoginForm.classList.toggle('hide');
    }
  }

  /****  Show reset password success message **/
  function resetPasswordSuccess(){
    var formState = document.querySelector('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!formState){
      return;
    }

    // show success message
    var resetSuccess = document.getElementById('ResetSuccess');
    if (resetSuccess){
      resetSuccess.classList.remove('hide');
    }
  }

  /****  Show/hide customer address forms **/
  function customerAddressForm(){
    var newAddressForm = document.getElementById('AddressNewForm');

    if (!newAddressForm){
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify){
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew',{
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    var countryOptions = document.querySelectorAll('.address-country-option');
    countryOptions.forEach(function(el){
      var formId = el.dataset.formId;
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector,{
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    var newToggles = document.querySelectorAll('.address-new-toggle');
    newToggles.forEach(function(el){
      el.addEventListener('click', function(){
        newAddressForm.classList.toggle('hide');
      });
    });

    var editToggles = document.querySelectorAll('.address-edit-toggle');
    editToggles.forEach(function(el){
      el.addEventListener('click', function(){
        var formId = el.dataset.formId;
        var editAddress = document.getElementById('EditAddress_' + formId);
        if (editAddress){
          editAddress.classList.toggle('hide');
        }
      });
    });

    var deleteButtons = document.querySelectorAll('.address-delete');
    deleteButtons.forEach(function(el){
      el.addEventListener('click', function(){
        var formId = el.dataset.formId;
        var confirmMessage = el.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')){
          Shopify.postLink('/account/addresses/' + formId,{parameters:{_method: 'delete'}});
        }
      });
    });
  }

  /****  Check URL for reset password hash **/
  function checkUrlHash(){
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover'){
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function(){
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();
theme.customerTemplates.init();
